import React from 'react';
import { FaBriefcase, FaGraduationCap, FaUsers } from 'react-icons/fa';
import './Careers.css';

const Careers = () => {
  const benefits = [
    { icon: <FaBriefcase />, text: 'Exposure to multidisciplinary assignments' },
    { icon: <FaGraduationCap />, text: 'Internal training across audit, tax, IT, analytics & soft skills' },
    { icon: <FaUsers />, text: 'Supportive and structured learning environment' }
  ];

  const openings = [
    { title: 'Audit Executive', description: 'Conduct statutory and internal audits, ensuring compliance and accuracy' },
    { title: 'Accounting Associate', description: 'Handle bookkeeping, reconciliations, and financial reporting' },
    { title: 'IT Audit Assistant', description: 'Support IT audits, security assessments, and technology assurance' },
    { title: 'Articles/Audit Trainees', description: 'Training opportunities for aspiring Chartered Accountants' }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  return (
    <section id="careers" className="careers section">
      <div className="container">
        <div className="section-header center animate-on-scroll">
          <span className="section-label">Join Us</span>
          <h2>Grow Your Career with Us</h2>
        </div>
        <div className="careers-intro animate-on-scroll">
          <p>We believe that our people are our greatest asset. At Xavier & Xavier, you will work in a professional, collaborative environment that encourages continuous learning and skill enhancement.</p>
        </div>

        <div className="careers-benefits">
          <h3 className="animate-on-scroll">What We Offer</h3>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-item animate-on-scroll">
                {benefit.icon}
                <p>{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="current-openings">
          <h3 className="animate-on-scroll">Current Openings</h3>
          <div className="openings-grid">
            {openings.map((opening, index) => (
              <div key={index} className="opening-card animate-on-scroll">
                <h4>{opening.title}</h4>
                <p>{opening.description}</p>
              </div>
            ))}
          </div>
          <div className="center">
            <button className="btn-primary" onClick={scrollToContact}>Apply Now</button>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Careers;
